export const LOWEST_NOTIFY_INFO_REQUEST = 'LOWEST_NOTIFY_INFO_REQUEST';
export const LOWEST_NOTIFY_INFO_SUCCESS = 'LOWEST_NOTIFY_INFO_SUCCESS';
export const LOWEST_NOTIFY_INFO_FAIL = 'LOWEST_NOTIFY_INFO_FAIL';
export const LOWEST_NOTIFY_UPDATE_REQUEST = 'LOWEST_NOTIFY_UPDATE_REQUEST';
export const LOWEST_NOTIFY_UPDATE_SUCCESS = 'LOWEST_NOTIFY_UPDATE_SUCCESS';
export const LOWEST_NOTIFY_UPDATE_FAIL = 'LOWEST_NOTIFY_UPDATE_FAIL';
export const LOWEST_NOTIFY_UPDATE_RESET = 'LOWEST_NOTIFY_UPDATE_RESET';
